import styled from "styled-components";

export const ContainerDropshipping = styled.div`
  color: ${(props) => props.theme.colors.tertiary};
  text-align: left;

  .descricao {
    padding: 3rem 0;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .secao {
    margin-top: 4rem;

    .titulo-secao {
      font-weight: 600;
      margin-bottom: 1rem;
    }
  }

  .formulario {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    align-items: flex-end;
    gap: 2rem;
    margin-top: 2rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .chaves {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 3rem;
  }

  .chave {
    border: 1px solid ${(props) => props.theme.colors.elements};
    border-radius: 1rem;
    padding: 2rem;

    &.desconectado {
      border-color: ${(props) => props.theme.colors.alert};
    }

    .cabecalho {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 2rem;
      flex-wrap: wrap;
    }

    .nome {
      font-weight: 600;
    }

    .info {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .flag-desconectado {
      padding: 0.3rem 1.4rem;
      border-radius: 20px;
      line-height: normal;
      background-color: ${(props) => props.theme.colors.alert};
      color: ${(props) => props.theme.colors.white};
      font-size: 12px;
      @media (max-width: 768px) {
        font-size: 10px;
      }
    }

    .valor-chave {
      cursor: pointer;
      text-decoration: underline;
      word-break: break-all;
    }

    .acoes {
      display: flex;
      gap: 2rem;

      span {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .aviso {
    margin-top: 1rem;
    opacity: 0.8;
  }
`;
